import GuaNav from "@/components/feature/GuaNav";
import GuaFooter from "@/components/feature/GuaFooter";
import Hero from "./components/Hero";
import Columns from "./components/Columns";
import Hot from "./components/Hot";
import Faq from "./components/Faq";
import About from "./components/About";

export default function Home() {
  return (
    <>
      <GuaNav />
      <main>
        <Hero />
        <Columns />
        <Hot />
        <Faq />
        <About />
      </main>
      <GuaFooter />
    </>
  );
}